import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportNamePipe } from './passport-name.pipe';

@NgModule({
  declarations: [PassportNamePipe],
  imports: [CommonModule],
  exports: [PassportNamePipe],
})
export class PassportNameModule {}
